import { render, staticRenderFns } from "./AddCabinet.vue?vue&type=template&id=ec8828a0&"
import script from "./AddCabinet.vue?vue&type=script&lang=ts&"
export * from "./AddCabinet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports